import { render, staticRenderFns } from "./edit-base-warranty.vue?vue&type=template&id=53871dff&"
import script from "./edit-base-warranty.vue?vue&type=script&lang=js&"
export * from "./edit-base-warranty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports